/** RBAC mapping. */

import type { UserRole } from "./types";

type ResourceAction = string; // например "products:edit", "users:delete"

const PERMISSIONS: Record<ResourceAction, UserRole[]> = {
  // Products
  "products:list": ["admin", "manager", "warehouse", "viewer"],
  "products:show": ["admin", "manager", "warehouse", "viewer"],
  "products:create": ["admin", "manager"],
  "products:edit": ["admin", "manager"],
  "products:delete": ["admin"],

  // Categories
  "categories:list": ["admin", "manager", "warehouse", "viewer"],
  "categories:create": ["admin", "manager"],
  "categories:edit": ["admin", "manager"],
  "categories:delete": ["admin"],

  // Orders
  "orders:list": ["admin", "manager", "warehouse", "viewer"],
  "orders:show": ["admin", "manager", "warehouse", "viewer"],
  "orders:update_status": ["admin", "manager", "warehouse"],
  "orders:cancel": ["admin", "manager"],
  "orders:refund": ["admin"],

  // Clients
  "clients:list": ["admin", "manager", "viewer"],
  "clients:show": ["admin", "manager", "viewer"],
  "clients:edit": ["admin", "manager"],
  "clients:block": ["admin", "manager"],

  // Reviews
  "reviews:list": ["admin", "manager", "viewer"],
  "reviews:moderate": ["admin", "manager"],
  "reviews:delete": ["admin", "manager"],

  // Stock
  "stock:list": ["admin", "manager", "warehouse", "viewer"],
  "stock:edit": ["admin", "warehouse"],

  // Bonuses
  "bonuses:list": ["admin", "manager", "viewer"],
  "bonuses:grant": ["admin", "manager"],

  // Promo codes
  "promo-codes:list": ["admin", "manager", "viewer"],
  "promo-codes:create": ["admin", "manager"],
  "promo-codes:edit": ["admin", "manager"],
  "promo-codes:delete": ["admin"],

  // Banners
  "banners:list": ["admin", "manager", "viewer"],
  "banners:edit": ["admin", "manager"],

  // Settings
  "settings:view": ["admin", "manager", "viewer"],
  "settings:edit": ["admin"],

  // Admin Users (только admin)
  "admin-users:list": ["admin"],
  "admin-users:create": ["admin"],
  "admin-users:edit": ["admin"],
  "admin-users:delete": ["admin"],

  // Audit
  "audit:view": ["admin"],

  // Analytics
  "analytics:view": ["admin", "manager", "viewer"],
};

export function can(role: UserRole | undefined, action: ResourceAction): boolean {
  if (!role) return false;
  const allowed = PERMISSIONS[action];
  if (!allowed) {
    // Default: read-only actions allowed for all
    if (action.endsWith(":list") || action.endsWith(":show")) return true;
    return false;
  }
  return allowed.includes(role);
}

export function canAny(
  role: UserRole | undefined,
  actions: ResourceAction[],
): boolean {
  return actions.some((a) => can(role, a));
}
